<template>
  <div :style="{ position: 'relative' }">
    <Loading
      :active.sync="loading"
      :isFullPage="false"
      :zIndex="9000"
    ></Loading>
    <Dialog
      id="'dialog-confirm-data'"
      :visible.sync="show"
      :style="{ width: $isMobile() ? '100vw' : '40vw' }"
      v-bind:class="[{ 'p-dialog-maximized': $isMobile() }]"
      :modal="true"
      :header="'Confirmar Folha de Obra'"
    >
      <form name="validateForm" class="p-col-12" @submit.prevent="validate">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-12" style="margin-top: 10px">
            <span class="p-float-label">
              <Textarea
                id="report"
                name="report"
                type="text"
                v-model="report"
                v-validate="'required'"
                :autoResize="true"
                rows="5"
                v-bind:class="[
                  {
                    'p-invalid': errors.has('report'),
                  },
                  'form-control',
                ]"
              />
              <label for="report">Relatório</label>
            </span>
            <small v-if="errors.has('report')" class="p-error" role="alert">
              Relatório é obrigatório
            </small>
          </div>
        </div>
      </form>
      <Message
        v-if="!workSheet"
        :sticky="true"
        :closable="false"
        severity="warn"
      >
        Não Existe Folha de Obra, deseja continuar com o check out?
      </Message>
      <div v-else>
        <Message
          v-if="!allToday"
          :sticky="true"
          :closable="false"
          severity="warn"
        >
          Existe Material instalado noutro dia, valide tudo antes de prosseguir
          com check out.
        </Message>
        <div class="p-d-flex p-flex-column">
          <span><b>Marca: </b>{{ workSheet.equipament.brand }}</span>
          <span class="p-mt-1"
            ><b>Modelo: </b>{{ workSheet.equipament.model }}</span
          >
          <span class="p-mt-1"
            ><b>Número de Série: </b>
            {{ workSheet.equipament.serial_number }}</span
          >
          <span class="p-mt-1"
            ><b>Estado da Garantia: </b> {{ workSheet.equipament.status }}</span
          >
          <span class="p-mt-1" v-if="workSheet.equipament.end_warranty != ''"
            ><b>Fim da Garantia: </b
            >{{ workSheet.equipament.end_warranty }}</span
          >
        </div>
        <divider />
        <span v-if="!allToday" class="p-mt-2">
          <i
            class="not-add-today p-mr-1"
            style="min-width: 30px; min-height: 30px"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </i>
          Material não instalado hoje
          <divider />
        </span>
        <span v-if="!$isMobile()">
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-md-2">
              <b>Quantide</b>
            </div>
            <div class="p-md-2">
              <b>Referência</b>
            </div>
            <div class="p-md-8">
              <b>Material</b>
            </div>
          </div>

          <divider />
          <div
            v-for="(line, index) in workSheet.lines"
            :key="index"
            v-bind:class="[
              { 'not-add-today': !line.addedToday && !allToday },
              'p-fluid p-formgrid p-grid',
            ]"
          >
            <div class="p-md-2">
              {{ line.quantity }}
            </div>
            <div class="p-md-2">
              {{ line.reference }}
            </div>
            <div class="p-md-8">
              {{ line.design }}
            </div>
            <divider />
          </div>
        </span>
        <span v-else>
          <div
            v-for="(line, index) in workSheet.lines"
            :key="index"
            v-bind:class="[
              { 'not-add-today': !line.addedToday && !allToday },
              'p-d-flex p-flex-column',
            ]"
          >
            <div><b>Quantidade: </b>{{ line.quantity }}</div>
            <div class="p-mt-1"><b>Referência: </b>{{ line.reference }}</div>
            <div class="p-mt-1"><b>Designação: </b>{{ line.design }}</div>
            <divider />
          </div>
        </span>
      </div>
      <template #footer>
        <Button
          :label="'Confirmar'"
          icon="pi pi-check"
          class="p-button-success"
          @click="validate"
        />
        <Button
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-danger"
          @click="close"
        />
      </template>
    </Dialog>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import supportService from "../../services/support.service";
export default {
  name: "WorkSheet",
  props: ["show", "task_id"],
  components: { Loading },
  watch: {
    async show() {
      if (this.show === true) {
        this.$validator.resume();
        this.workSheet = await this.getWorkSheet();
      } else {
        this.reset();
      }
    },
  },
  data() {
    return {
      loading: false,
      allToday: true,
      workSheet: null,
      report: null,
    };
  },
  methods: {
    reset() {
      this.workSheet = null;
      this.report = null;
      this.allToday = true;
      return (this.loading = false);
    },
    close() {
      this.reset();
      return this.$emit("close");
    },
    validate() {
      this.$validator.validateAll().then((isValid) => {
        if (!isValid) {
          this.loading = false;
          return;
        }
        this.$validator.pause();
        return this.saveReport();
      });
    },
    saveReport() {
      this.loading = true;
      let data = {
        report: this.report,
        status: this.status,
      };
      supportService.addReport(this.task_id, data).then((response) => {
        this.loading = false;
        if (!response) {
          return this.$toast.add({
            severity: "error",
            summary: "Erro ao Inserir Relatório",
            detail: "Ocorreu um erro ao guardar o relatório",
            life: 3000,
          });
        }
        this.$toast.add({
          severity: "success",
          summary: "Relatório Inserido",
          detail: "O relatório foi inserido com sucesso",
          life: 3000,
        });
        return this.$emit("confirmedWorkSheet");
      });
    },
    getWorkSheet() {
      this.loading = true;
      return supportService.getWorkSheet(this.task_id).then((response) => {
        this.loading = false;
        if (!response) {
          return;
        }
        response.lines.forEach((line) => {
          if (!line.addedToday) {
            this.allToday = false;
            return;
          }
        });
        return response;
      });
    },
  },
};
</script>
<style scoped>
.add-today {
  background-color: #a8eda9;
}
.not-add-today {
  background-color: #eada9a;
}
</style>
